export default {
  api: {
    url: 'https://ww-gateway-qa.wnwd.com'
  },
  frontegg: {
    baseUrl: 'https://login-qa.wnwd.com',
    clientId: '25c44fa2-6aea-4f39-aa7b-0a699eb9da03',
    playgroundAppId: 'aa49dd8c-6f8e-483c-b252-77d175ad9a96',
    abuTaggingAppId: '42000b55-85a0-47aa-972b-846a96747993',
  },
};
